// frontend/src/GiftCards/GiftCards.jsx — /gift-cards: every job, newest first.
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePinnedHeights } from '../ItAssets/ItAssets';
import { useAuth } from '../AuthComponent';
import { gcApi, openBlob } from './apiClient';
import { Alert, JobPill, Progress, money, useList, when } from './common';

export default function GiftCards() {
  const navigate = useNavigate();
  const { nameOf } = useAuth();
  const { data, error, reload } = useList(() => gcApi.jobs(), []);
  useEffect(() => { if (!data || !data.running) return undefined; const t = setInterval(reload, 3000); return () => clearInterval(t); }, [data, reload]);
  const setPage = usePinnedHeights();
  const jobs = (data && data.jobs) || [];
  const cards = jobs.reduce((n, j) => n + Number(j.cards_loaded), 0);
  const value = jobs.reduce((n, j) => n + Number(j.total_value), 0);
  const print = async (j) => { try { openBlob(await gcApi.pdf(j.id), `gift-cards-job-${j.id}.pdf`); } catch (e) { window.alert(e.message); } };
  return (
    <section className="uh-page uh-ia-page" ref={setPage}>
      <div className="uh-ia-top">
        <div className="uh-ph">
          <div>
            <h1 className="uh-h1">Gift Cards</h1>
            <div className="uh-sub">Creates Lightspeed gift cards, one or many at a time, and prints them as cut-out sheets. Every creation is a job you can reopen.</div>
          </div>
          {data && (
            <div className="uh-ia-stats">
              {[[jobs.length, 'Jobs'], [cards, 'Cards created'], [money(value), 'Total value']].map(([v, k]) => (
                <div className="stat" key={k}><span className="v uh-num">{typeof v === 'number' ? v.toLocaleString() : v}</span><span className="k">{k}</span></div>))}
            </div>
          )}
        </div>
      </div>
      <Alert>{error}</Alert>
      {data && !data.production && <div className="uh-kpc-banner info">This server is not on the production database, so jobs here are dry runs: nothing reaches Lightspeed.</div>}
      <div className="uh-card">
        <div className="uh-card-h"><h2 className="uh-h2 lg">Jobs</h2><span className="uh-sp" />
          <button type="button" className="uh-btn primary" disabled={data && data.running} title={data && data.running ? 'Wait for the running job to finish' : ''} onClick={() => navigate('/gift-cards/new')}>New job</button></div>
        <div className="uh-tscroll"><table className="uh-tbl">
          <thead><tr><th>#</th><th>Started</th><th>By</th><th>Purpose</th><th>Club</th><th className="r">Cards</th><th>Progress</th><th>Status</th><th /></tr></thead>
          <tbody>
            {jobs.map((j) => (
              <tr key={j.id} className="uh-row-link" onClick={() => navigate(`/gift-cards/jobs/${j.id}`)}>
                <td className="uh-mono">#{j.id}</td><td className="uh-ia-nowrap">{when(j.created_at)}</td><td>{nameOf(j.created_by)}</td><td>{j.purpose}</td>
                <td>{j.club ? <>{j.club}{j.billable_to_club && <span className="uh-ia-tag" style={{ marginLeft: 6 }}>Billable</span>}</> : <span className="uh-faint">—</span>}</td>
                <td className="r uh-num">{Math.abs(Number(j.total_value) - j.count * Number(j.amount)) < 0.005 ? <>{j.count} × {money(j.amount)}</> : <>{j.count} cards, {money(j.total_value)}</>}</td>
                <td><Progress done={Number(j.cards_loaded)} total={Number(j.cards_total)} failed={Number(j.cards_failed)} cancelled={Number(j.cards_cancelled || 0)} /></td>
                <td><JobPill job={j} />{j.dry_run && <span className="uh-ia-tag" style={{ marginLeft: 6 }}>Dry run</span>}</td>
                <td className="r uh-ia-nowrap" onClick={(e) => e.stopPropagation()}>
                  <button type="button" className="uh-btn slim" onClick={() => navigate(`/gift-cards/jobs/${j.id}`)}>Open</button>{' '}
                  <button type="button" className="uh-btn slim" disabled={!Number(j.cards_loaded)} onClick={() => print(j)}>Print</button></td>
              </tr>))}
            {data && !jobs.length && <tr><td colSpan={9}><div className="uh-empty">No jobs yet. A job creates one or many gift cards in Lightspeed and keeps their codes here.</div></td></tr>}
          </tbody></table></div>
      </div>
    </section>
  );
}
